import { render } from "./TriggerHistoryShow.vue?vue&type=template&id=157ac10a"
import script from "./TriggerHistoryShow.vue?vue&type=script&lang=js"
export * from "./TriggerHistoryShow.vue?vue&type=script&lang=js"
script.render = render

export default script